import { StringParam } from "serialize-query-params";

export const analyticsParamsMap = {
	stsl: StringParam,
};
